import { useState, useEffect, useMemo } from 'react';

import "./App.css";
import Nav from "./Nav";
import Modal from './Modal'

import logo from "./assets/Logo.svg";
import map from "./assets/map.svg";

import pp from "./assets/pp.svg";
import fast from "./assets/fast.svg";
import safety from "./assets/safety.svg";

import AppleIcon from "./assets/AppleIcon";
import AndroidIcon from "./assets/AndroidIcon";
import AppGalleryIcon from "./assets/AppGalleryIcon";
import RuStoreIcon from "./assets/RuStoreIcon";

import mokap from './assets/Мокап.png'

import air from './assets/airplane.svg'
import car from './assets/car.svg'
import train from './assets/train.svg'

import one from './assets/one.svg'
import two from './assets/two.svg'
import three from './assets/three.svg'
import four from './assets/four.svg'
import five from './assets/five.svg'

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return width;
}

function App() {
  const width = useWindowWidth();
  const [open, setOpen] = useState(false)
  const [contentNumber, setContentNumber] = useState(1)
  const sections = useMemo(() => ['', 'about', 'advantages', 'app'], []); // ID секций
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);

  function handleOpenModal(content) {
    setContentNumber(content)
    setOpen(true)
  }

  useEffect(() => {
    const handleScroll = () => {
      const offsets = sections.map((id) =>
        id ? document.getElementById(id)?.offsetTop || 0 : 0 // Если id пустой, считаем начало страницы
      );
      const scrollPosition = window.scrollY + window.innerHeight / 2; // Центр экрана

      // Найти текущую секцию
      const index = offsets.findIndex(
        (offset, i) =>
          scrollPosition >= offset &&
          (i === offsets.length - 1 || scrollPosition < offsets[i + 1])
      );

      setCurrentSectionIndex(index === -1 ? 0 : index);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);

  const handleNextSection = () => {
    if (currentSectionIndex === sections.length - 1) {
      // Если последняя секция, отправляем на верх
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const nextIndex = currentSectionIndex + 1;
      const nextSection = sections[nextIndex]
        ? document.getElementById(sections[nextIndex])
        : document.body; // Если id пустой, прокрутка к началу страницы
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="App">
      <Nav width={width} onClick={handleNextSection} rotate={currentSectionIndex} />
      <div className="firstScreen">
      {width <= 1024 &&
            <p className='service'>
              Сервис доставки посылок
              <br />с использованием попутных перевозок
            </p>
          }
        <div className="forLogo">
          <img src={logo} alt="logo" className="logo" />
        </div>
        <div className="helloTextBlock">
          {width > 1024 &&
            <p>
              Сервис доставки посылок
              <br />с использованием попутных перевозок
            </p>
          }
          <h1 className='logoText'>POSTAPP</h1>
        </div>
      </div>
      <div className="secondScreen" id='about'>
        <div className="container">
          <h1>Что это такое?</h1>
          <p>
            Приложение "PostApp" – это удобный сервис доставки посылок
            <br />с использованием попутных перевозок.
          </p>
        </div>
        <div className="container" style={{gap: '50px', flex: '1'}}>
          <h2>Как это работает:</h2>
          { width > 700 ?
          <div className="maps">
            <div className="map mapTop">
              <p>
                Укажите маршрут
                <br />и параметры посылки
              </p>
              <p>
                Свяжитесь с попутчиком
                <br />и передайте посылку
              </p>
            </div>
            <div className="map mapBot">
              <p>
                Система подберет подходящих
                <br />
                попутчиков, которые едут
                <br />в нужном направлении
              </p>
              <p>
                Попутчик доставит
                <br />
                посылку получателю
              </p>
            </div>
            <img src={map} alt="Карта" className="mapImg" />
          </div>
          :
          <div className='mobileMaps'>
            <img src={one} alt="линия" className='oneLine'/>
             <p>
                Укажите маршрут
                <br />и параметры посылки
              </p>
              <img src={two} alt="линия" />
              <p>
                Свяжитесь с попутчиком
                <br />и передайте посылку
              </p>
              <img src={three} alt="линия" />
              <p>
                Система подберет подходящих
                <br />
                попутчиков, которые едут
                <br />в нужном направлении
              </p>
              <img src={four} alt="линия" />
              <p>
                Попутчик доставит
                <br />
                посылку получателю
              </p>
              <img src={five} alt="линия" className='fiveLine'/>
          </div>
          }
        </div>
      </div>
      <div className="thirdScreen" id='advantages'>
        <h1>Почему Мы?</h1>
        <div className="slider">
          <div className="slide">
            <h3>1.</h3>
            <div className="content">
              <img src={pp} alt="Передавать" className="contentImg" />
              <p>Передавайте посылки без<br/>лишних хлопот</p>
            </div>
          </div>
          <div
            className="slide"
            style={{
              borderRight: width > 472 ? "1px solid #292929" : '',
              borderLeft: width > 472 ? "1px solid #292929" : '',
              borderTop: width <= 472 ? "1px solid #292929" : '',
              borderBottom: width <= 472 ? "1px solid #292929" : '',
            }}
          >
            <h3>2.</h3>
            <div className="content">
              <img src={fast} alt="Быстрая" className="contentImg" />
              <p>Быстрая и выгодная<br/>доставка</p>
            </div>
          </div>
          <div className="slide">
            <h3>3.</h3>
            <div className="content">
              <img src={safety} alt="Надежно" className="contentImg" />
              <p>Надежно и удобно</p>
            </div>
          </div>
        </div>
        <div className="container" style={{paddingTop: '80px'}}>
          <p>Отправлять посылки через "PostApp" быстрее и дешевле чем через другой сервис, 
          потому что они доставляются попутчиком.</p>
          <div className="delivery">
            <h2>ВИДЫ ДОСТАВКИ:</h2>
            <div className="deliveryContainer">
              <div className="variations">
                <div className="variation">
                  <span className="number">1.</span>
                  <p className="variationText">На самолете <img src={air} alt="На самолете" /></p>
                </div>
                <div className="variation">
                  <span className="number">2.</span>
                  <p className="variationText">На автомобиле <img src={car} alt="На автомобиле" /></p>
                </div>
                <div className="variation">
                  <span className="number">3.</span>
                  <p className="variationText">На поезде <img src={train} alt="На поезде" /></p>
                </div>
              </div>
              <h3>получая посылки для перевозки можно компенсировать стоимость путешествия </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="fourScreen" id='app'>
        <div className="whiteContainer">
          <h1>Доставка в 2 клика</h1>
          <div className="wrapper">
            <div className="wrapperContent">
              <p>
                Скачайте наше приложение и откройте для себя удобный
                <br />и выгодный способ доставки посылок{" "}
              </p>
              <div className="offer">
                <h2>Вместе проще - по пути</h2>
                <div className="buttons">
                  <div className="buttonsRow">
                    <a
                      className="button"
                      href="https://apps.apple.com/ru/app/postapp/id6755620001"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AppleIcon size={'clamp(20px, 6vw, 89px)'}/>
                      <div className="textBtn">
                        <p>Доступно в</p>
                        <h3>App Store</h3>
                      </div>
                    </a>
                    <a
                      className="button"
                      href="https://play.google.com/store/apps/details?id=com.larhatdreen.PostApp"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AndroidIcon size={'clamp(20px, 6vw, 89px)'}/>
                      <div className="textBtn">
                        <p>Загрузите на</p>
                        <h3>Google play</h3>
                      </div>
                    </a>
                  </div>
                  <div className="buttonsRow">
                    <a
                      className="button"
                      href="https://appgallery.cloud.huawei.com/ag/n/app/C115635517?locale=ru_RU&source=appshare&subsource=C115635517&shareTo=com.android.bluetooth&shareFrom=appmarket&shareIds=01c4fafd0d38428eb57b689fec611511_com.android.bluetooth&callType=SHARE"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <AppGalleryIcon size={'clamp(20px, 6vw, 89px)'}/>
                      <div className="textBtn">
                        <p>Доступно в</p>
                        <h3>AppGallery</h3>
                      </div>
                    </a>
                    <a
                      className="button"
                      href="https://www.rustore.ru/catalog/app/com.larhatdreen.PostApp"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <RuStoreIcon size={'clamp(20px, 6vw, 89px)'}/>
                      <div className="textBtn">
                        <p>Загрузите в</p>
                        <h3>RuStore</h3>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="phone">
            <img src={mokap} alt="Телефон" className="mokap"/>
            </div>
          </div>
        </div>
        <footer>
          <div className="rules">
            <button className="openRulesbtn" onClick={() => handleOpenModal(1)}>
              Политика конфиденциальности
            </button>
            <button className="openRulesbtn" onClick={() => handleOpenModal(2)}>
              Пользовательское соглашение
            </button>
            <button className="openRulesbtn" onClick={() => handleOpenModal(3)}>
              Политика обработки персональных данных
            </button>
          </div>
          <div className="contacts">
            <h4>КОНТАКТЫ</h4>
            <a href="tel:89024520555">8 902 452 05 55</a>
            <a href="mailto:postapp_service@mail.ru">postapp_service@mail.ru</a>
          </div>
        </footer>
      </div>
      <Modal open={open} onClose={() => setOpen(false)} content={contentNumber} />
    </div>
  );
}

export default App;
